// Youssef Selkani
// 2019

import React, { Component } from 'react'
import '../App.css'
import { Form, Image, Radio, Button, Grid, Segment, Container } from 'semantic-ui-react'
import fire from '../config/Fire'

export default class AdMob extends Component {
  constructor (props) {
    super(props)
    this.state = {
      loading: true
    }
  }

  componentDidMount = () => {
    fire.auth().onAuthStateChanged((user) => {
      if (user) {
        let raw = user.email
        let userUnderscore = raw.replace(/\./g, '_')
        this.setState({
          userUnderscore: userUnderscore
        })
        this.userData()
      } else {
        this.props.history.push('/')
      }
    })
  }
  userData = (e) => {
    fetch('https://murkstomstag.herokuapp.com/api/v1/user/data', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        userUnderscore: this.state.userUnderscore
      })
    })
      .then((response) => {
        return response.json()
      })
      .then((obj) => {
        if ((obj.code = 200)) {
          this.setState({
            admob: obj.admob,
            userPos: obj.bannerAdPosition,
            loading: false
          })
        } else {
          this.setState({
            loading: false,
            error: 'Internal Server Error | code 500'
          })
        }
      })
      .catch((error) => {
        console.log(error)
        this.setState({ error: error.message, loading: false })
      })
  }

  enableAdmob = () => {
    this.setState({ loading: true })
    const objUpdate = {
      admob: this.state.admobID,
      bannerAdPosition: this.state.userPos
    }
    const cloneObjUpdate = { ...objUpdate }
    Object.keys(objUpdate).forEach((key) => {
      if (!cloneObjUpdate[key]) cloneObjUpdate[key] = null
    })
    fetch('https://murkstomstag.herokuapp.com/api/v1/enable/admob', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        userUnderscore: this.state.userUnderscore,
        cloneObjUpdate: cloneObjUpdate
      })
    }).then((response) => {
      if (response.status === 200) {
        window.location.reload()
      } else {
        this.setState({ error: 'Internal Server Error |  code 500', loading: false })
      }
    })
  }

  disableAdmob = () => {
    this.setState({ loading: true })
    fetch('https://murkstomstag.herokuapp.com/api/v1/disable/admob', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        userUnderscore: this.state.userUnderscore
      })
    }).then((response) => {
      if (response.status === 200) {
        window.location.reload()
      } else {
        this.setState({ error: 'Internal Server Error |  code 500', loading: false })
      }
    })
  }

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value })
  }

  handleRadio = (e, { value }) => this.setState({ userPos: value })

  render () {
    let { saved, userPos, loading, error, admobID, admob } = this.state
    return (
      <Container className='masterdiv'>
        <div className='mb center'>
          <Image
            centered
            style={{ width: '30px' }}
            src='https://4.bp.blogspot.com/-Lv-lgKjS7BI/XD0BYRjz6_I/AAAAAAAAG3s/zvnKfXxolm4Spt1wQ5hvm0nCx3lDytN_ACK4BGAYYCw/s1600/logo%2Badmob%2Bvector.png'
          />
          <h2>Google AdMob</h2>
        </div>

        <Grid reversed='mobile' centered stackable verticalAlign='top' fluid={true}>
          <Grid.Column width='2' />
          <Grid.Column width='10'>
            <div className='screen-card'>
              <Segment basic padded>
                {!admob ? (
                  <Form>
                    <Form.Input
                      label='AdMob Unit ID'
                      type='text'
                      onChange={this.handleChange}
                      placeholder='xxx-xxx-xxxx'
                      name='admobID'
                      value={admobID}
                    />
                    <Form.Button
                      content={!saved ? 'Submit' : 'Saved'}
                      onClick={() => this.enableAdmob()}
                      basic={!saved}
                      loading={loading}
                      error={error}
                      color='black'
                    />
                  </Form>
                ) : (
                  <div>
                    <div className='mbs'>
                      <p>Unit ID: {admob}</p>
                    </div>
                    <Button
                      content='Disable'
                      color='red'
                      onClick={() => this.disableAdmob()}
                      basic
                      compact
                    />
                  </div>
                )}
              </Segment>
            </div>
          </Grid.Column>
          <Grid.Column width='4'>
            <div className='screen-card'>
              <Segment fluid basic>
                <h5>Ad Banner Position</h5>
                <div className='mbs'>
                  <Radio
                    disabled={admob}
                    toggle
                    label='top'
                    name='radioGroup'
                    value='top'
                    checked={userPos === 'top'}
                    onChange={this.handleRadio}
                  />
                </div>
                <Radio
                  disabled={admob}
                  toggle
                  style={{ marginLeft: '5%' }}
                  defaultChecked
                  label='bottom'
                  name='radioGroup'
                  value='bottom'
                  checked={userPos === 'bottom'}
                  onChange={this.handleRadio}
                />
              </Segment>
            </div>
          </Grid.Column>
          <Grid.Column width='2' />
        </Grid>
      </Container>
    )
  }
}
